import useSWR from 'swr';
import { getUserId } from '@core/auth/redux';
import { useReduxState } from '@engage/redux/hooks';
import { UserPreferencesFetchers } from '@members/data-fetch';
import { useLocale } from '@members/localization';

export const usePrivacyQuestionsData = (
  country: string,
  subRegion: string,
  v2Enabled?: boolean,
) => {
  const locale = useLocale();
  const userId = useReduxState(getUserId);
  return useSWR(
    ...UserPreferencesFetchers.GetPrivacyQuestions(
      {
        acceptLanguage: locale,
        userId,
      },
      {
        country,
        subRegion,
        v2Enabled,
      },
    ),
  );
};

export const useLocationPromptData = () => {
  const locale = useLocale();
  const userId = useReduxState(getUserId);
  return useSWR(
    ...UserPreferencesFetchers.GetLocationPrompt({
      acceptLanguage: locale,
      userId,
    }),
  );
};

export const useLocationData = () => {
  const locale = useLocale();
  const userId = useReduxState(getUserId);
  return useSWR(
    ...UserPreferencesFetchers.GetLocationData({
      acceptLanguage: locale,
      userId,
    }),
  );
};

export const useGenericPromptData = () => {
  const locale = useLocale();
  return useSWR(
    ...UserPreferencesFetchers.getGenericLocationPrompt({
      acceptLanguage: locale,
    }),
  );
};
